<template lang="pug">
Poptip(:title="$t('certsmanage.explainPoptipTitle')" transfer @on-popper-show="get")
    template(slot="content")
        div(style="display: flex; flex-direction: column")
            p {{ $t("certsmanage.explainPoptipContentForWildcard") }}
            p Name: {{ cnameName }}
            CopyText(:text="cnameValue", :copyText="`Value: ${cnameValue}`")
            div(v-if="$can('write', 'domainManagePermission','FQDNConfig')" style="display: flex; flex-direction: row; justify-content: flex-end")
                Button(@click="regenerate") {{ $t("certsmanage.regenerateWildcardCsrBtn") }}
    Icon(:type="iconType", :size="24", :color="iconColor")
</template>

<script>
import { getWildcardCSR, regenerateWildcardCSR } from "@/api/certs";

export default {
    name: "WildcardCsrPoptip",
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            cnameName: "",
            cnameValue: "",
        };
    },
    methods: {
        async get() {
            try {
                const { groupName, servername } = this.params.row;
                const response = await getWildcardCSR({ groupName, servername });
                const { CNAME_Host, CNAME_Value } = response.data.data || {};
                this.cnameName = CNAME_Host;
                this.cnameValue = CNAME_Value;
            } catch (error) {
                console.error("Failed to get CSR", error);
            }
        },
        async regenerate() {
            try {
                const { groupName, servername } = this.params.row;
                const response = await regenerateWildcardCSR({ groupName, servername });
                const { CNAME_Host, CNAME_Value } = response.data.data || {};
                this.cnameName = CNAME_Host;
                this.cnameValue = CNAME_Value;
            } catch (error) {
                console.error("Failed to regenerate CSR", error);
            }
        },
    },
    computed: {
        iconType() {
            return this.params.row.hasSystemCert ? "ios-information-circle-outline" : "md-warning";
        },
        iconColor() {
            return this.params.row.hasSystemCert ? "grey" : "orange";
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/WildcardCSRPoptip.vue